var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-head-container" },
    [
      _c("div", { staticClass: "page-head clearfix" }, [
        _c("div", { staticClass: "page-head-info clearfix" }, [
          _vm.hasHeaderTopSlot
            ? _c(
                "div",
                { staticClass: "page-head-extra-top" },
                [_vm._t("header-top")],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.hasHeaderTopSlot
            ? _c("div", [
                _c(
                  "a",
                  {
                    staticClass: "back",
                    on: {
                      click: function ($event) {
                        return _vm.navBack()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          < " + _vm._s(_vm.$t("back")) + "\n        "
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row clearfix description-group" }, [
            _c("div", { staticClass: "page-tenancy-description" }, [
              _c(
                "div",
                { staticClass: "page-tenancy-description-title" },
                [
                  _c("span", [_vm._v(_vm._s(_vm.title))]),
                  _vm._v(" "),
                  _vm.canToggleStatus
                    ? _c(
                        "DottedMenu",
                        {
                          staticClass:
                            "page-tenancy-description-title-dotted-menu",
                          attrs: { color: "darkblue" },
                        },
                        [
                          _vm.showInactiveButton
                            ? _c(
                                "HKLButton",
                                {
                                  staticClass:
                                    "page-tenancy-description-title-dotted-menu-option no-min-height",
                                  on: {
                                    click: function () {
                                      return _vm.toggleTenancyStatus()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t("tenancy.statusToggle.inactive")
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              )
                            : _c(
                                "HKLButton",
                                {
                                  staticClass:
                                    "page-tenancy-description-title-dotted-menu-option no-min-height",
                                  on: {
                                    click: function () {
                                      return _vm.toggleTenancyStatus()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t("tenancy.statusToggle.active")
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix tools-bar" }, [
                _c(
                  "div",
                  { staticClass: "float-left tools-bar__status-box" },
                  [
                    _vm.currentTenancy.status
                      ? _c("HKLStatusBadge", {
                          staticClass:
                            "float-left tenant-project-status pointer",
                          attrs: {
                            value: _vm._f("uppercase")(
                              _vm._f("customStatusLabel")(
                                _vm.currentTenancy.status
                              )
                            ),
                          },
                          on: { click: _vm.openLifecycle },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isEngineer
                      ? _c(
                          "div",
                          { staticClass: "last-update-info float-left " },
                          [
                            _vm.currentTenancy.manager
                              ? _c(
                                  "div",
                                  { staticClass: "last-update float-left" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "last-update__text" },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(_vm.createdByOn) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentTenancy.updater
                              ? _c(
                                  "div",
                                  { staticClass: "last-update float-left" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "last-update__text" },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(_vm.lastUpdatedByOn) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "buttons-slot" },
                  [_vm._t("default")],
                  2
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("TenancyStatusLifecycle", { ref: "lifecycleModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }